<div id="toast-container" (click)='navigateToDetail()'>
    <div>
        <div style="display: flex;">
            <span>{{data.customerFullName}}</span>
            <span style="font-weight: bold;" class="tmi tmi-close"></span>
        </div>
        <div *ngIf="data.vehicleInfo">{{data.vehicleInfo}}</div>
        <div style="font-weight:600; padding-bottom: 12px; border-bottom: 2px solid rgba(255, 255, 255, 0.36)">{{data.salesPerson}}</div>
        <div style="font-weight:600; padding-top: 7px">{{data.writeupType}}</div>
        <div>{{data.status}}</div>
        <div *ngIf="data.onlineStatus">
            <img style="position: relative;top: 2px;margin-right: 3px;" src="assets/images/online-status-icon-blue.svg" alt=""> {{data.onlineStatus}}
        </div>
    </div>
</div>